var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameScriptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 2C3.75552 2 3 2.75552 3 3.6875L3 15.3125C3 16.2444 3.75552 17 4.6875 17H13.3125C14.2444 17 15 16.2444 15 15.3125V3.6875C15 2.75552 14.2444 2 13.3125 2L4.6875 2ZM4.125 3.6875C4.125 3.37684 4.37684 3.125 4.6875 3.125L13.3125 3.125C13.6231 3.125 13.875 3.37684 13.875 3.6875V15.3125C13.875 15.6231 13.6231 15.875 13.3125 15.875H4.6875C4.37684 15.875 4.125 15.6231 4.125 15.3125L4.125 3.6875ZM5.8125 5.375C5.50184 5.375 5.25 5.62684 5.25 5.9375C5.25 6.24816 5.50184 6.5 5.8125 6.5L12.1875 6.5C12.4981 6.5 12.75 6.24816 12.75 5.9375C12.75 5.62684 12.4981 5.375 12.1875 5.375H5.8125ZM5.25 12.6875C5.25 12.3769 5.50184 12.125 5.8125 12.125H12.1875C12.4981 12.125 12.75 12.3769 12.75 12.6875C12.75 12.9981 12.4981 13.25 12.1875 13.25H5.8125C5.50184 13.25 5.25 12.9981 5.25 12.6875ZM5.8125 8.75C5.50184 8.75 5.25 9.00185 5.25 9.3125C5.25 9.62315 5.50184 9.875 5.8125 9.875H12.1875C12.4981 9.875 12.75 9.62315 12.75 9.3125C12.75 9.00185 12.4981 8.75 12.1875 8.75H5.8125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameScriptIcon);
export default __webpack_public_path__ + "static/media/game-script-icon.fc0eebdc42f33b49f30a8e9066cb8415.svg";
export { ForwardRef as ReactComponent };